exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.task-status-container[data-v-2e422b63] {\n  padding: 20px;\n}\n.pagination-container[data-v-2e422b63] {\n  margin-top: 20px;\n  text-align: right;\n}\n.click-text[data-v-2e422b63] {\n  color: #409EFF;\n  cursor: pointer;\n}\n.red-time[data-v-2e422b63] {\n  color: #f56c6c;\n  font-weight: 600;\n}\n.description[data-v-2e422b63] {\n  margin-top: 10px;\n  font-size: 13px;\n  color: #606266;\n}\n", ""]);

// exports
